"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceSortByEnum = void 0;
var ResourceSortByEnum;
(function (ResourceSortByEnum) {
    ResourceSortByEnum["NAME"] = "name";
    ResourceSortByEnum["RESOURCE_TYPE"] = "resourceType";
    ResourceSortByEnum["INVOICE_ID"] = "invoiceId";
})(ResourceSortByEnum = exports.ResourceSortByEnum || (exports.ResourceSortByEnum = {}));
//# sourceMappingURL=connected-resources.enums.js.map